import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ModalDirective } from 'ngx-bootstrap';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LoadingIndicatorService } from '../../../../services/loading-indicator/loading-indicator.service';
import { EventsService } from '../../../../services/events/events.service';
import { environment } from '../../../../../environments/environment';
import * as moment from 'moment/moment';

@Component({
  selector: 'tripmakery-booking-payment-partner-edit-modal',
  templateUrl: './modal-booking-payment-partner-edit.component.html',
  styleUrls: ['./modal-booking-payment-partner-edit.component.css']
})
export class ModalBookingPaymentPartnerEditComponent implements OnInit {
  public bookingId: string;
  public booking: any;
  public environment_;
  public form: FormGroup;
  public formAdd: FormGroup;
  public is100PercentPayout: boolean = false;

  @ViewChild('childModal') public childModal: ModalDirective;

  constructor(private http: HttpClient,
              private loadingIndicatorService: LoadingIndicatorService,
              private eventsService: EventsService,
              private fb: FormBuilder) {
    this.resetFormData();
    this.environment_ = environment;
  }

  ngOnInit() {
    this.eventsService.on('requestShowModalBookingPaymentPartnerEdit', (bookingId) => {
      this.booking = null;
      this.bookingId = bookingId;
      this.resetFormData();
      this.loadAutoPayouts();
      this.showChildModal();
    });
  }

  private loadAutoPayouts() {
    this.loadingIndicatorService.showLoadingBar();
    this.http.get(environment.urls.service + '/api/v1/authenticated/admin/booking/auto-payouts/' + this.bookingId)
      .subscribe(
        (response: any) => {
          this.booking = response.booking;
          this.fillFormData();
          this.setHundredPercentPayoutData();
        },
        (error) => {
          this.eventsService.broadcast('requestShowErrorMessage', JSON.stringify(error));
        },
        () => {
          this.loadingIndicatorService.hideLoadingBar();
        }
      );
  }

  private resetFormData() {
    this.form = this.fb.group({
      rows: this.fb.array([])
    });

    this.formAdd = new FormGroup({
      'amount': new FormControl({value: ''}),
      'scheduledFor': new FormControl({value: moment.utc().toDate()})
    });

    this.formAdd.setValue({amount: null, scheduledFor: null});
  }

  get rows(): FormArray {
    return this.form.get('rows') as FormArray;
  }

  trackByIndex = (i: number) => i;

  private fillFormData() {
    const rows = this.rows;
    for (const payout of this.booking.autoPayoutDetails.payouts) {
      rows.push(this.fb.group({
        _id: payout._id,
        amount: payout.amount,
        currency: payout.currency,
        isScheduledForTransaction: payout.isScheduledForTransaction == null ? false : payout.isScheduledForTransaction,
        scheduledFor: payout.scheduledFor != null ? moment.utc(payout.scheduledFor).toDate() : null,
        revolutPaymentDraftId: payout.revolutPaymentDraftId,
        revolutPaymentId: payout.revolutPaymentId,
        revolutTransactionId: payout.revolutTransactionId,
        transactionState: payout.transactionState,
        link: '',
      }));
    }
  }

  private setHundredPercentPayoutData() {
    if (this.booking != null &&
      this.booking.autoPayoutDetails != null &&
      this.booking.autoPayoutDetails.hundredPercentPayouts === true) {
      this.is100PercentPayout = true;
      return;
    }

    this.is100PercentPayout = false;
  }

  public showChildModal(): void {
    this.childModal.show();
  }

  public hideChildModal(): void {
    this.childModal.hide();
  }

  public handleRemoveElement(index: number) {
    const formData = this.rows.at(index);
    const payoutId = formData.get('_id').value;

    this.http.delete(environment.urls.service + '/api/v1/authenticated/admin/booking/auto-payouts/' + this.bookingId + '/auto-payouts/' + payoutId)
      .subscribe(
        (response: any) => {
          this.booking = response.booking;
          this.resetFormData();
          this.loadAutoPayouts();
        },
        (error) => {
          this.eventsService.broadcast('requestShowErrorMessage', JSON.stringify(error));
        },
        () => {
        }
      );
  }

  public handleUpdateElement(index: number) {
    const formData = this.rows.at(index);
    const payoutId = formData.get('_id').value;

    this.http.patch(environment.urls.service + '/api/v1/authenticated/admin/booking/auto-payouts/' + this.bookingId + '/auto-payouts/' + payoutId, {
      amount: formData.get('amount').value,
      scheduledFor: formData.get('scheduledFor').value,
      isScheduledForTransaction: formData.get('isScheduledForTransaction').value,
      link: this.createNullIfEmptyString(formData.get('link').value),
    })
      .subscribe(
        (response: any) => {
          this.booking = response.booking;
          this.resetFormData();
          this.loadAutoPayouts();
        },
        (error) => {
          /* */
          if (error.error.message === 'E_VALIDATION_FAILED') {
            console.log('Just a validation Error');
            try {
              for (const localError of error.error.errors) {
                formData.get(localError.property).setErrors(localError.constraints);
                formData.get(localError.property).markAsDirty();

                console.log(localError.property, localError.constraints);
              }
            } catch (error) {
              console.log('Catched Error while trying to map data', error);
            }
            return;
          }

          /* */
          this.eventsService.broadcast('requestShowErrorMessage', JSON.stringify(error));
        },
        () => {
        }
      );
  }

  public handleAddElement() {
    const formData = this.formAdd;

    this.http.post(environment.urls.service + '/api/v1/authenticated/admin/booking/auto-payouts/' + this.bookingId + '/auto-payouts/', {
      amount: formData.get('amount').value,
      scheduledFor: formData.get('scheduledFor').value,
    })
      .subscribe(
        (response: any) => {
          this.booking = response.booking;
          this.resetFormData();
          this.loadAutoPayouts();
        },
        (error) => {
          /* */
          if (error.error.message === 'E_VALIDATION_FAILED') {
            console.log('Just a validation Error');
            try {
              for (const localError of error.error.errors) {
                formData.get(localError.property).setErrors(localError.constraints);
                formData.get(localError.property).markAsDirty();

                console.log(localError.property, localError.constraints);
              }
            } catch (error) {
              console.log('Catched Error while trying to map data', error);
            }
            return;
          }

          this.eventsService.broadcast('requestShowErrorMessage', JSON.stringify(error));
        },
        () => {
        }
      );
  }

  public handleToggleHundredPercentPayout() {
    const formData = this.formAdd;

    this.http.post(environment.urls.service + '/api/v1/authenticated/admin/booking/auto-payouts/' + this.bookingId + '/toggle-hundred-percent-payouts', {
    })
      .subscribe(
        (response: any) => {
          this.booking = response.booking;
          this.resetFormData();
          this.loadAutoPayouts();
        },
        (error) => {
          /* */
          if (error.error.message === 'E_VALIDATION_FAILED') {
            console.log('Just a validation Error');
            try {
              for (const localError of error.error.errors) {
                formData.get(localError.property).setErrors(localError.constraints);
                formData.get(localError.property).markAsDirty();

                console.log(localError.property, localError.constraints);
              }
            } catch (error) {
              console.log('Catched Error while trying to map data', error);
            }
            return;
          }

          this.eventsService.broadcast('requestShowErrorMessage', JSON.stringify(error));
        },
        () => {
        }
      );
  }

  private createNullIfEmptyString(s: string) {
    if (s != null && typeof s === 'string' && s.trim() === '') {
      return null;
    }
    return s;
  }

  private createFalseIfEmptyString(s: string) {
    if (s != null && typeof s === 'string' && s.trim() === '') {
      return false;
    }
    return s;
  }

  public extractValidationErrorsAsArray(errors) {
    if (errors == null) {
      return [];
    }

    const errorsToReturn = [];
    Object.keys(errors).forEach(key => {
      errorsToReturn.push(errors[key]);
    });

    return errorsToReturn;
  }

}
